<template>
  <div class="container">
    <div class="row">
      <div class="page-body overlap">
        <h1 class="page-title">My Account</h1>

        <div class="flex-body two-col">
          <div class="body-side">
            <AccountNavigation />
          </div>

          <div class="body-main">
            <div class="content-panel">
              <div class="panel-title">
                <h3>{{ title }}</h3>
              </div>
              <div class="panel-body">
                <p v-if="showErrors" class="invalid">Please correct the errors in red.</p>

                <div class="form-group">
                  <label for="">Email</label>
                  {{ userEmail }}
                  <p class="description">Please contact a Platform Admin to change your account email address.</p>
                </div>

                <div class="form-group">
                  <label for="">Current Password</label>
                  <input type="password" v-model="userCurrentPassword" autocomplete='off' name="Current Password" />
                  <p class="description">Enter your current password above.</p>
                </div>

                <div class="form-group">
                  <label for="">Update Password</label>
                  <input type="password" v-model="userNewPassword" autocomplete='off' name="New Password" />
                  <p class="description">Enter a new password above. Leave blank to keep current password.</p>
                </div>

                <button class="btn btn-lg btn-full" @click="updateAccountDetails()">Save Changes</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {auth} from "@/firebaseConfig";
import AccountNavigation from '@/components/AccountNavigation'

export default {
  name: 'Settings',
  components: {
    'AccountNavigation': AccountNavigation
  },

  data () {
    return {
      title: 'Account Settings',
      user: auth.currentUser,
      userEmail: auth.currentUser.email,
      userCurrentPassword: '',
      userNewPassword: '',
      showErrors: false
    }
  },

  metaInfo: {
    title: 'Account Settings',
  },

  methods: {
    updateAccountDetails: function() {
      var newPassword = this.userNewPassword;
      var currentUser = this.user;
      var userEmail = this.userEmail;
      var userCurrentPassword = this.userCurrentPassword;
      var $notify = this.$notify;

      this.$validator.validateAll().then((result) => {
        if (result && currentUser.email.toLowerCase() === userEmail.trim().toLowerCase()) {
          auth.signInWithEmailAndPassword(userEmail, userCurrentPassword).then(
                  (user) => {
                    currentUser.updatePassword(newPassword).then(function() {
                      $notify({
                        group: 'saved',
                        title: 'Password changed successfully',
                        type: 'success'
                      });
                    }).catch(function(error) {
                      console.log('Oops. ' + error.message);
                    });
                  },
                  (err) => {
                    console.log('Oops. ' + err.message)
                  }
          );
          this.showErrors = false
        }
        else { this.showErrors = true }
      })
    }
  },
}
</script>